import { type Id, toast, type TypeOptions } from 'react-toastify';

/**
 * Updates an existing toast notification.
 *
 * @param toastId - The ID of the toast to update.
 * @param message - The new message to display in the toast.
 * @param type - The type of toast notification (e.g., 'success', 'error', 'info', 'warning').
 *
 * @example
 * ```typescript
 * // Update an existing toast to show a success message
 * updateToast('toast-1', 'Operation completed successfully', 'success');
 * ```
 *
 * @public
 */
export const updateToast = (toastId: Id, message: string, type: TypeOptions) => {
  toast.update(toastId, {
    render: message,
    type: type,
    isLoading: false,
    autoClose: 3000,
  });
};
